(function ($) {
  'use strict';

  $(function () {
    // Close breadcrumbs overflow menu if clicking outside
    $(document).on("click", function (event) {
      const $menuContainer = $(".qld__overflow_menu_wrapper");

      // If the click is outside the nav menu
      if (
        !$menuContainer.is(event.target) &&
        $menuContainer.has(event.target).length === 0
      ) {
        $menuContainer.find(".collapse.show").each(function () {
          const collapseInstance = bootstrap.Collapse.getInstance(this);
          if (collapseInstance) {
            collapseInstance.hide();
          }
        });
      }
    });
  });
})(jQuery);